import { render, staticRenderFns } from "./SlideMenu.vue?vue&type=template&id=80cce1b2&scoped=true&"
import script from "./SlideMenu.vue?vue&type=script&lang=ts&"
export * from "./SlideMenu.vue?vue&type=script&lang=ts&"
import style0 from "./SlideMenu.vue?vue&type=style&index=0&id=80cce1b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cce1b2",
  null
  
)

export default component.exports